/**
 * Neya Systems, LLC disclaims all warranties with regard to this software,
 * including all implied warranties of merchantability and fitness, in no
 * event shall Neya Systems, LLC be liable for any special, indirect or
 * consequential damages or any damages whatsoever resulting from loss of
 * use, data or profits, whether in an action of contract, negligence or
 * other tortious action, arising out of or in connection with the use or
 * performance of this software.
 *
 * "Copyright (c) 2020 Neya Systems, LLC, all rights reserved."
 *
 * This work contains valuable confidential and proprietary information.
 * Disclosure or reproduction without the written authorization of Neya
 * Systems, LLC is prohibited. This unpublished work by Neya Systems, LLC
 * is protected by the laws of the United States and other countries. If
 * publication of the work should occur, the following notice shall apply.
 */

function isProduction() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        // dev code
        return false
    } else {
        // production code
        return true
    }
}

export function getHost() {
    const host = isProduction()
        ? `${window.location.protocol}//${window.location.hostname}`
        : process.env.REACT_APP_HOST
    return host
}

export function getBackend() {
    return `${getHost()}${process.env.REACT_APP_BACKEND}`
}

export function getGraphQLBackend() {
    return `${getHost()}${process.env.REACT_APP_GRAPHQL_SERVICE}`
}

export function getDownloadService() {
    return `${getHost()}${process.env.REACT_APP_DOWNLOADSERVICE}`
}

export function getBagUploadLocation() {
    return `${getHost()}${process.env.REACT_APP_UPLOAD_BAG}`
}

export function getVizAddress() {
    console.log(`ENV: ${process.env.REACT_APP_VIZ}`)
    return `${getHost()}${process.env.REACT_APP_VIZ}`
}
